import styled from 'styled-components';
import { StyledUiContainerProps } from 'components';
import theme from 'common/theme';

export const MachineCardWidgetHeader = styled.h2`
  font-weight: 600;
  cursor: pointer;
  font-size: 1rem !important;
  line-height: 1.172rem;
  padding-bottom: 1.25rem;
  display: flex;
  align-items: center;
  gap: 0.35rem;
  .icon--triangle-warning {
    width: 18px;
    height: 18px;
  }
`;

export const MachineCardWidgetContainer = styled.div<StyledUiContainerProps>`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;

  .widget__image {
    width: 100%;
    height: 200px;
    overflow: hidden;
    display: flex;
    justify-content: center;
    align-items: center;
    .machine-image {
      width: 100%;
      height: auto;
      object-fit: cover;
    }
  }

  .widget__service-status{
    display: flex;
    padding: 0.5rem;
    justify-content: space-between;
    align-items: center;
    align-self: stretch;
    border-radius: 8px;
    font-size: 0.75rem ;
    .widget__service-status-text {
      display: flex;
      align-items: center;
      gap: 0.5rem;
      margin: 0;
    }
    .widget__service-status-value {
      margin: 0;
    }
    .service-status-icon {
      width: 16px;
      height: 16px;
    }
  }

  .icon--wrench {
    width: 16px;
    height: 16px;
  }

  .widget__tags{
    .first-row-item, .first-header {
      text-align: left;
      margin-left: 0;
    }
    .first-row-item {
      padding-left: 0;
    }
  }
`;

export const ServiceStatusContainer = styled.div<{ serviceStatusColor?: string, serviceStatusBackgroundColor?: string }>`
  border: 2px solid ${({ serviceStatusColor }) => serviceStatusColor || theme.colors.mainColor};
  background: ${({ serviceStatusBackgroundColor }) => serviceStatusBackgroundColor || theme.colors.Blue200};
  color: ${({ serviceStatusColor }) => serviceStatusColor || theme.colors.mainColor};
`;
